import Vue from 'vue'
import App from './App.vue'

import AddPresent from './components/AddPresent'
import WishList from './components/WishList'
import Order from './components/Order'

import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import VueResource from 'vue-resource'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import UUID from "vue-uuid";

import Oauth from './plugins/Oauth'
import Api from './plugins/Api'

Vue.config.productionTip = false
Vue.prototype.$baseApiUrl = 'https://api.ma-wishlist.com/'

const routes = [
  { path: '/add', component: AddPresent},
  { path: '/add/:owner', component: AddPresent},
  { path: '/list/:user', component: WishList, name: "userlist"}, 
  { path: '/list', component: WishList}, 
  { path: '/', component: WishList},
  { path: '/order', component: Order},
  { path: '/order/:owner', component: Order},
]

var router = new VueRouter({
  routes: routes,
  mode: 'history'
})

Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VueResource);
Vue.use(VueToast);
Vue.use(UUID);


Vue.http.interceptors.push(function(request) {
  request.headers.set('Authorization', 'Bearer ' + Vue.$cookies.get('access_token'));
});

Vue.use(Oauth, {
  baseUrl: window.location.protocol + "//" + window.location.host + "/",
  baseOauthUrl: 'https://oauth.ma-wishlist.com/',
  clientId: '3vsp6fs5catualq8mjgj8io5il'
})
Vue.use(Api, {
  baseApiUrl: 'https://api.ma-wishlist.com/'
})

new Vue({
  router: router,
  render: h => h(App)
}).$mount('#app')
